import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import AuthorizedMenu from './AuthorizedMenu';
import UnAuthorizedMenu from './UnAuthorizedMenu';
import { saleMenus, saleMenusDelivering, consignmentMenus, cardSaleMenuKeys } from '../../utils/authorization';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.handleIsActive = this.handleIsActive.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  }

  activeRoutes(routeNames = []) {
    routeNames.map(name => {
      if (this.props.location.pathname.indexOf(name) > -1) {
        return 'nav-item nav-dropdown open'
      }
    })

    return 'nav-item nav-dropdown'
  }

  handleIsActive(match){
    return match !== null && match.isExact;
  }

  renderAuthorisedSaleMenusDelivering = (authorisedSaleMenusDelivering) => {
    if (authorisedSaleMenusDelivering.length === 0) return null;
    
    // Define the desired order
    const order = [
      'sales/jnt-delivering',
      'sales/tiki-delivering',
      'sales/spx-delivering',
      'sales/instant-delivering',
      'sales/warehouse-delivering',
      'sales/other-delivering'
    ];
    
    // Sort the menu items according to the order
    const sortedMenus = order.filter(item => authorisedSaleMenusDelivering.includes(item));
    
    return sortedMenus.map((v, i) => (
      <li className="nav-item" key={i}>
        <NavLink to={`/${v}`} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>{saleMenusDelivering[v]}</NavLink>
      </li>
    ));
  }

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }

  render() {
    const { authData } = this.props;
    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <ul className="nav">
            {/* Users */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="users"
              render={()=>(
                <li className="nav-item">
                  <NavLink to={'/users'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="icon-user"></i> Users</NavLink>
                </li>
              )}
            />

            {/* Product Catalogue */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName={['categories', 'subcategories', 'brands', 'products', 'product_addons', 'product_variants']}
              render={() => (
                <li className={this.activeRoutes(['/categories', '/subcategories', '/brands', '/products', '/product_addons', '/product_variants'])}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-shopping-bag"></i> Product Catalogue</a>
                  <ul className="nav-dropdown-items">
                    {/* subcategories */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="subcategories"
                      render={()=>(
                        <li className={this.activeRoute("/subcategories")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Subcategory</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/subcategories/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Subcategory</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/subcategories'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Subcategory List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* brands */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="brands"
                      render={()=>(
                        <li className={this.activeRoute("/brands")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Brands</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/brands/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Brand</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/brands'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Brand List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* products */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="products"
                      render={()=>(
                        <li className={this.activeRoute("/products")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Sets</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/products/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Set</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/products'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Set List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* product addons */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="product_addons"
                      render={()=>(
                        <li className={this.activeRoute("/product_addons")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Product Addons</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/product_addons/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}> Create Product Addon</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/product_addons'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}> Product Addon List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* product_variants */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="product_variants"
                      render={()=>(
                        <li className={this.activeRoute("/product_variants")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Product Variants</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/product_variants/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Product Variant</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/product_variants'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Product Variant List</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/product_variants/sku_requests'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>SKU Requests</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                  </ul>
                </li>
              )}
            />

            {/* Platform Content */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName={['collections', 'sliders', 'pop_up_banner']}
              render={() => (
                <li className={this.activeRoutes(['/collections', '/sliders', '/pop_up_banner'])}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-picture-o"></i> Platform Content</a>
                  <ul className="nav-dropdown-items">
                    {/* collections */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="collections"
                      render={()=>(
                        <li className={this.activeRoute("/collections")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-folder"></i> Collections</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/collections/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Collection</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/collections'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Collection List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* sliders */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="sliders"
                      render={()=>(
                        <li className={this.activeRoute("/sliders")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="icon-picture"></i> Sliders</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/sliders/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Slider</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/sliders'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Slider List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />

                    {/* Pop Up Banner */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="pop_up_banner"
                      render={()=>(
                        <li className={this.activeRoute("/pop_up_banner")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-image"></i> Pop Up Banner</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/pop_up_banner/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}> Create Pop Up Banner</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/pop_up_banner'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}> Pop Up Banner List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />
                  </ul>
                </li>
              )}
            />

            {/* Sale Process */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName={['sales']}
              render={()=>{
                const hasOne = authData.authRoutes.filter(i => i !== 'sales').length === 1;
                const first = hasOne? authData.authRoutes.filter(i => i !== 'sales')[0]: null;
                const authorisedSaleMenusDelivering = authData.authRoutes.filter(v => Object.keys(saleMenusDelivering).includes(v));
                return(
                  <li className={this.activeRoute("/sales")}>
                    <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-line-chart"></i> Sale Process</a>
                    <ul className="nav-dropdown-items">
                      {cardSaleMenuKeys.map((i, key) => (
                        <AuthorizedMenu
                          key={key}
                          isLoading={authData.isFetch}
                          routes={authData.authRoutes}
                          routeName={i}
                          render={()=> {
                            if(i === 'sales/delivering'){
                              if(first === 'sales/delivering'){
                                return (
                                  <>
                                    {this.renderAuthorisedSaleMenusDelivering(authorisedSaleMenusDelivering)}
                                  </>
                                )
                              }
                              return (
                                <li className="nav-item nav-dropdown">
                                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}>{saleMenus[i]}</a>
                                  <ul className="nav-dropdown-items">
                                    {this.renderAuthorisedSaleMenusDelivering(authorisedSaleMenusDelivering)}
                                  </ul>
                                </li>
                              )
                            }
                            return(
                              <li className="nav-item">
                                <NavLink to={`/${i}`} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>{saleMenus[i]}</NavLink>
                              </li>
                            )
                          }}
                        />
                      ))}
                    </ul>
                  </li>
                )
              }}
            />

            {/* Offers/Bids */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="offers"
              render={()=>(
                <li className="nav-item">
                  <NavLink to={'/offers'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="icon-envelope-letter"></i> Offers/Bids</NavLink>
                </li>
              )}
            />

            {/* Vouchers */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="vouchers"
              render={()=>(
                <li className={this.activeRoute("/vouchers")}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-ticket"></i> Vouchers</a>
                  <ul className="nav-dropdown-items">
                    <li className="nav-item">
                      <NavLink to={'/vouchers/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Voucher</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={'/vouchers'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Voucher List</NavLink>
                    </li>
                  </ul>
                </li>
              )}
            />

            {/* Inventory */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName={['sell_request', 'warehouse', 'stock', 'racks']}
              render={() => (
                <li className={this.activeRoutes(['/sell_request', '/warehouse', '/stock', '/racks'])}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-archive"></i> Inventory</a>
                  <ul className="nav-dropdown-items">
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="sell_request"
                      render={()=>(
                        <li className="nav-item">
                          <NavLink to={'/sell_request'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="fa fa-map-signs"></i> Sell & Consignment Request</NavLink>
                        </li>
                      )}
                    />
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="warehouse"
                      render={()=>(
                        <li className="nav-item">
                          <NavLink to={'/warehouse'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="fa fa-database"></i> Warehouse</NavLink>
                        </li>
                      )}
                    />
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="stock"
                      render={()=>(
                        <li className="nav-item">
                          <NavLink to={'/stock'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="icon-drawer"></i> Stock</NavLink>
                        </li>
                      )}
                    />
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="racks"
                      render={()=>(
                        <li className={this.activeRoute("/racks")}>
                          <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-bars"></i> Rack</a>
                          <ul className="nav-dropdown-items">
                            <li className="nav-item">
                              <NavLink to={'/racks/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Rack</NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink to={'/racks'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Rack List</NavLink>
                            </li>
                          </ul>
                        </li>
                      )}
                    />
                  </ul>
                </li>
              )}
            />

            {/* Consignment */}
            <UnAuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="consignment"
              render={()=>{
                const hasOne = authData.authRoutes.filter(i => i !== 'consignment').length === 1;
                const first = hasOne? authData.authRoutes.filter(i => i !== 'consignment')[0]: null;
                return(
                  <li className={this.activeRoute("/consignment")}>
                    <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-archive"></i> Consignment</a>
                    <ul className="nav-dropdown-items">
                      {Object.keys(consignmentMenus).filter(i => i!=='consignment').map((i, key) => (
                        <UnAuthorizedMenu
                          key={key}
                          isLoading={authData.isFetch}
                          routes={authData.authRoutes}
                          routeName={i}
                          render={()=> {
                            if(i === 'consignment/delivering'){
                              if(first === 'consignment/delivering'){
                                return (
                                  <>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/jnt-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>JNT</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/instant-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Gosend/Grab</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/warehouse-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Warehouse</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/other-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Others</NavLink>
                                    </li>
                                  </>
                                )
                              }
                              return (
                                <li className="nav-item nav-dropdown">
                                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}>{consignmentMenus[i]}</a>
                                  <ul className="nav-dropdown-items">
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/jnt-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>JNT</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/instant-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Gosend/Grab</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/warehouse-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Warehouse</NavLink>
                                    </li>
                                    <li className="nav-item">
                                      <NavLink to={'/consignment/other-delivering'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Others</NavLink>
                                    </li>
                                  </ul>
                                </li>
                              )
                            }
                            return(
                              <li className="nav-item">
                                <NavLink to={`/${i}`} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>{consignmentMenus[i]}</NavLink>
                              </li>
                            )
                          }}
                        />
                      ))}
                    </ul>
                  </li>
                )
              }}
            />

            {/* Finance */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName={['seller_verification']}
              render={() => (
                <li className={this.activeRoutes(['/seller_verification'])}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-money"></i> Finance</a>
                  <ul className="nav-dropdown-items">
                    {/* Seller Verification */}
                    <AuthorizedMenu
                      isLoading={authData.isFetch}
                      routes={authData.authRoutes}
                      routeName="seller_verification"
                      render={()=>(
                        <li className="nav-item">
                          <NavLink to={'/seller_verification'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="fa fa-check-square-o"></i> Seller Verification</NavLink>
                        </li>
                      )}
                    />
                  </ul>
                </li>
              )}
            />

            {/* Create Payment */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="payments/create"
              render={()=>(
                <li className="nav-item">
                  <NavLink to={'/payments/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="fa fa-exchange"></i> Create Payment</NavLink>
                </li>
              )}
            />

            {/* Top Up */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="top_up"
              render={()=>(
                <li className="nav-item">
                  <NavLink to={'/top_up'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}><i className="icon-wallet"></i> Top Up</NavLink>
                </li>
              )}
            />

            {/* FAQ */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="faqs"
              render={()=>(
                <li className={this.activeRoute("/faqs")}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-question-circle"></i> FAQ</a>
                  <ul className="nav-dropdown-items">
                    <li className="nav-item">
                      <NavLink to={'/faqs/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create FAQ</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={'/faqs'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>FAQ List</NavLink>
                    </li>
                  </ul>
                </li>
              )}
            />

            {/* Setting */}
            <AuthorizedMenu
              isLoading={authData.isFetch}
              routes={authData.authRoutes}
              routeName="setting"
              render={()=>(
                <li className={this.activeRoute("/setting")}>
                  <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleClick.bind(this)}><i className="fa fa-cog"></i> Setting</a>
                  <ul className="nav-dropdown-items">
                    <li className="nav-item">
                      <NavLink to={'/setting/create'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Create Setting</NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to={'/setting'} className="nav-link" activeClassName="active" isActive={this.handleIsActive}>Setting List</NavLink>
                    </li>
                  </ul>
                </li>
              )}
            />

          </ul>
        </nav>
      </div>
    )
  }
}

export default connect()(Sidebar);
